// extracted by mini-css-extract-plugin
export default {"container":"Po-z","brandName":"Qo-z","productName":"Ro-z","productNamePdpEnhancements":"So-z","breakLongProductName":"To-z"};